export const transitionBigImageStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 1 },
  exiting: { opacity: 1 },
  exited: { opacity: 0 }
}

export const transitionImageStyles = {
  entering: { transform: 'scale(0)', opacity: 0 },
  entered: { transform: 'scale(1)', opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 }
}
